import './CPCE.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class CPCE extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
